module.exports = __webpack_public_path__ + "static/media/background.f8da1b41.jpg";